import { SuggestionHeader, SuggestionText, SuggestionCode, Link, SuggestionContainer } from './ErrorSuggestion.styles';
import { IProps } from '../ErrorPage';
import errorDetails from '../errorDetails';

const ErrorSuggestion = ({ errorCode }: IProps) => {
  return (
    <SuggestionContainer>
      <SuggestionHeader>What can I do?</SuggestionHeader>
      <SuggestionText>{errorDetails.get(errorCode)?.suggestion}</SuggestionText>
      <SuggestionText>
        <span>{errorDetails.get(errorCode)?.suggestion2} </span>
        <Link href="/">homepage</Link>.
      </SuggestionText>
      <SuggestionText>
        If you keep seeing this error, please get in touch at:{' '}
        <Link href="mailto:contact@enroly.com">contact@enroly.com</Link>
      </SuggestionText>
      <SuggestionCode>Error code: {errorCode} </SuggestionCode>
    </SuggestionContainer>
  );
};

export default ErrorSuggestion;
